// Enhanced Header Component
import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Box,
  Badge,
  Tooltip,
  Chip,
} from '@mui/material';
import {
  Menu as MenuIcon,
  Notifications,
  Help,
  Brightness4,
  Brightness7,
  Add,
} from '@mui/icons-material';
import authService from '../../services/auth';
import './Header.css';

const Header = ({ 
  onDrawerToggle, 
  onProfileMenuOpen,
  onQuickActionsOpen,
  pageTitle,
  isDarkMode,
  onToggleTheme 
}) => {
  const user = authService.getUser();

  return (
    <AppBar
      position="fixed"
      className="header-appbar"
    >
      <Toolbar>
        {/* Mobile Menu Button */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onDrawerToggle}
          className="header-mobile-menu-button"
        >
          <MenuIcon />
        </IconButton>

        {/* Page Title */}
        <Box className="header-page-title-container">
          {/* <Typography variant="h6" noWrap component="div" className="header-page-title">
            {pageTitle}
          </Typography> */}
        </Box>

        {/* Action Icons */}
        <Box className="header-action-icons">
          {/* Theme Toggle */}
          {/* <Tooltip title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
            <IconButton color="inherit" size="small" onClick={onToggleTheme}>
              {isDarkMode ? <Brightness7 /> : <Brightness4 />}
            </IconButton>
          </Tooltip> */}

          {/* Notifications */}
          {/* <Tooltip title="Notifications">
            <IconButton color="inherit" size="small">
              <Badge badgeContent={3} color="error">
                <Notifications />
              </Badge>
            </IconButton>
          </Tooltip> */}

          {/* Help */}
          {/* <Tooltip title="Help & Support">
            <IconButton color="inherit" size="small">
              <Help />
            </IconButton>
          </Tooltip> */}

          {/* Quick Actions */}
          <Tooltip title="Quick Actions">
            <IconButton 
              color="inherit" 
              size="small" 
              onClick={onQuickActionsOpen}
            >
              <Add /> Add
            </IconButton>
          </Tooltip>

          {/* User Info */}
          <Box className="header-user-info">
            <Box textAlign="right">
              <Typography variant="body2" className="header-user-text">
                {user?.first_name} {user?.last_name}
              </Typography>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="caption" className="header-user-role">
                  {user?.role_name || 'User'}
                </Typography>
                {user?.role_name === 'admin' && (
                  <Chip 
                    label="Admin" 
                    size="small" 
                    color="primary" 
                    className="header-admin-chip"
                  />
                )}
              </Box>
            </Box>

            {/* Avatar */}
            <Tooltip title="Account settings">
              <IconButton onClick={onProfileMenuOpen} size="small">
                <Avatar
                  className="header-user-avatar"
                >
                  {user?.first_name?.charAt(0)}{user?.last_name?.charAt(0)}
                </Avatar>
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
